import { Area } from './types';

export type MarketMapTypeAction = ViewingBoundsChanged | AreasLoaded | PatchArea | CreateArea | DeleteArea;

export interface ViewingBoundsChanged {
  type: 'MARKET_MAP_VIEWING_BOUNDS_CHANGED';
  data: any;
}

export interface PatchArea {
  type: 'MARKET_MAP_PATCH_AREA';
  data: Partial<Area>;
}

export interface CreateArea {
  type: 'MARKET_MAP_CREATE_AREA';
  data: Area;
}

export interface DeleteArea {
  type: 'MARKET_MAP_DELETE_AREA';
  data: Area;
}

export interface AreasLoaded {
  type: 'MARKET_MAP_AREAS_LOADED';
  data: Area[];
}

export function setAreas(areas: Area[]) {
  return {
    type: 'MARKET_MAP_AREAS_LOADED',
    data: areas,
  };
}

export function viewingBoundsDidChange(newBounds: any): ViewingBoundsChanged {
  return {
    type: 'MARKET_MAP_VIEWING_BOUNDS_CHANGED',
    data: newBounds,
  };
}

export function patchArea(area: Partial<Area>): PatchArea {
  return {
    type: 'MARKET_MAP_PATCH_AREA',
    data: area,
  };
}

export function createArea(area: Area): CreateArea {
  return {
    type: 'MARKET_MAP_CREATE_AREA',
    data: area,
  };
}

export function deleteArea(area: Area): DeleteArea {
  return {
    type: 'MARKET_MAP_DELETE_AREA',
    data: area,
  };
}
